import React from "react";
import { isFramed } from "../../lib/webauthn";

// Passkeys can't be created or used inside the Emergent preview frame: say so plainly, with a direct link.
export default function IframeBanner() {
  if (!isFramed()) return null;
  const url = window.location.href;
  return (
    <div role="note" className="rounded border border-erf-gold bg-erf-creamSecondary p-3 text-sm" data-testid="mfa-iframe-banner">
      <strong className="block font-nav">Open this site directly in Safari to add a passkey.</strong>
      <span className="text-xs text-erf-dark/80">Passkeys (Face ID / Touch ID) don't work inside the preview frame. The
        authenticator app and recovery codes work here.</span>
      <a href={url} target="_blank" rel="noopener noreferrer" className="mt-2 inline-flex min-h-[44px] items-center underline text-xs"
        data-testid="mfa-iframe-open-direct">Open directly</a>
    </div>
  );
}
